"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BaseMsg = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

/* eslint-disable */
var BaseMsg = /*#__PURE__*/function () {
  function BaseMsg() {
    (0, _classCallCheck2["default"])(this, BaseMsg);
  }

  (0, _createClass2["default"])(BaseMsg, null, [{
    key: "defaultMsg",
    value: function defaultMsg() {
      return {};
    }
  }]);
  return BaseMsg;
}();

exports.BaseMsg = BaseMsg;